import styled from 'styled-components';

import { fontStyles, palette } from 'theme';

export const P = styled.p`
  ${fontStyles.text};
  margin-bottom: 1em;
`;

export const Link = styled.a`
  ${fontStyles.text};
  color: ${palette.black};
  @media (hover) {
    &:hover {
      color: ${palette.darkGray};
    }
  }
`;
